<template>
<div :style="correlationStyle" @mousedown="startDrag" @mousemove="doDrag" @mouseup="stopDrag">
  <div class="box-head" >
    Allosteric Correlations
  </div>

  <div class="box-tool">
    <a :href="$store.state.host+`/dokhlab/actions/ohm/result?id=${task.id}&file=corr&as=${task.id}-correlation.txt`">{{task.id}}-correlation.txt</a> <a v-if="matrixReady" style="cursor:pointer" @click="downloadPng"> correlation-matrix.png</a> 
  </div>

  <div ref="correlationContainer" :style="correlationContainerStyle">
    <div v-if="hideMatrix">
      <el-button type="text" @click.native="showMatrix">View Correlation</el-button>
    </div>

    <div v-if="!hideMatrix && !matrixReady">
      Loading (This may take a few minutes) <i class="el-icon-loading"></i>
    </div>

    <div v-if="!hideMatrix && $store.state.task.results.ind.length>1000" style="padding:10px">
      As the pdb file has more than 1000 residues, we suggest you to download the '<a :href="$store.state.host+`/dokhlab/actions/ohm/result?id=${task.id}&file=corr&as=${task.id}-correlation.txt`">txt</a>' file of the correlation matrix and plot the correlation matrix in the local machine. We also provide the standalone version of Ohm for this type of analysis: <a href="https://bitbucket.org/dokhlab/ohm" target="_blank">Ohm</a>.
    </div>

    <div v-if="matrixReady">
      <b>Sort</b>
      <select id="correlation-order">
        <option value="sequence">by Sequence</option>
        <option value="aci">by ACI</option>
      </select>
    </div>

    <div id="correlation-matrix" :style="correlationMatrixStyle"></div>
  </div>

  <div :style="popupStyle" v-text="popupText"></div>

</div>
</template>

<script>
// import interpolate from 'color-interpolate'
// import Chart from 'chart.js'
// import 'chartjs-chart-matrix'
import { saveAs } from 'file-saver'
import * as d3 from 'd3'
import axios from 'axios'
import { saveSvgAsPng } from 'save-svg-as-png'

export default {
  name: 'Correlation',

  data () {
    return {
      active_site: [],
      allosteric_site: [],
      correlationStyle: {
//        border: '1px solid #eeeeee',
        margin: '20px 0px',
        position: 'relative',
        '-webkit-user-select': 'none',
        '-moz-user-select': 'none',
        '-khtml-user-select': 'none',
        '-ms-user-select': 'none'
      },
      correlationMatrixStyle: {
        fontSize: '10px',
        fontFamily: 'sans-serif',
        marginLeft: '80px',
        cursor: 'default'
      },
      popupText: '',
      popupStyle: {
        display: 'none',
        position: 'fixed',
        left: 0,
        top: 0,
        backgroundColor: 'black',
        color: 'white',
        fontSize: '12px',
        padding: '10px',
        borderRadius: '4px'
      },
      dragging: false,
      oldMousePosition: [],
      hideMatrix: true,
      matrixReady: false
    }
  },

  props: [ 'value' ],

  computed: {
    correlationContainerStyle () {
      return {
        position: 'relative',
        width: '100%',
//        height: this.$store.state.task.results.ind.length > 1000 ? 'auto' : '700px',
        overflowX: 'auto'
      }
    },

    task () {
      return this.$store.state.task
    }
  },

  methods: {
    downloadPng () {
//      console.log(saveSvgAsPng)
      saveSvgAsPng(document.getElementById('correlation-matrix-svg'), 'correlation-matrix.png')
    },

    startDrag () {
      this.dragging = true
      this.correlationMatrixStyle.cursor = 'pointer'
    },

    doDrag (e) {
      let v = this
      if (this.oldMousePosition) {
        var dx = e.clientX - this.oldMousePosition[0]
        var dy = e.clientY - this.oldMousePosition[1]
        if (this.dragging) {
          v.$refs.correlationContainer.scrollLeft -= dx
          v.$refs.correlationContainer.scrollTop -= dy
        }
      }
      this.oldMousePosition = [e.clientX, e.clientY]
    },

    stopDrag () {
      this.dragging = false
      this.correlationMatrixStyle.cursor = 'default'
    },

    download () {
      this.cyPromise.then(cy => {
        saveAs(cy.png({'output': 'blob'}), 'nodes.png')
      })
    },

    redirect (url) {
      window.location.href = url
    },

    openNewTab (url) {
      window.open(url, '_blank')
    },

    getInd (chainName, resNum) {
      for (let i of this.task.results.ind) {
        //        console.log(JSON.stringify(i))
        //        console.log(`${chainName}/${resNum}`)
        if (`${chainName}/${resNum}` === i.name) {
          return i.num
        }
      }
      return -1
      //      return this.task.results.ind.find(i => i.name === `${chainName}/${resNum}`).num
    },

    getSites (sites) {
      let vec = []
      let ls = sites.trim().split(/,/)
      for (let s of ls) {
        let w = s.split(/\//)
        let chainName = w[0]
        let residues = w[1]
        let v = residues.split(/\+/)
        for (let i of v) {
          let u = i.split(/-/)
          if (u.length === 2) {
            let a = parseInt(u[0])
            let b = parseInt(u[1])
            for (let j = a; j <= b; j++) {
              vec.push(this.getInd(chainName, j))
            }
          } else if (u.length === 1) {
            vec.push(this.getInd(chainName, u[0]))
          }
        }
      }
      return vec
    },

    showMatrix () {
      this.hideMatrix = false
      this.checkTask()
    },

    checkTask () {
      var task
      var v = this

      if (this.task) {
        let task = this.task

        var n = task.results.ind.length

        if (n > 1000) {
          return
        }

        let url = v.$store.state.host + `/dokhlab/actions/ohm/result?id=${task.id}&file=corr`
        console.log(url)
        console.log(task.results.ind.length)
        axios({
          method: 'get',
          url,
          withCredentials: true,
          transformResponse: []
        }).then(response => {
          var margin = {top: 80, right: 0, bottom: 10, left: 80}
          var width = n * 9
          var height = n * 9

//          var c = d3.scaleLinear().domain([0, 1]).range(['white', 'blue'])
          var c = d3.scaleLinear().domain([0, 1]).range(['#eee', 'blue'])

          var svg = d3.select('#correlation-matrix').append('svg')
          .attr('id', 'correlation-matrix-svg')
          .attr('width', width + margin.left + margin.right)
          .attr('height', height + margin.top + margin.bottom)
          .style('margin-left', -margin.left + 'px')
          .append('g')
          .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')')

          var lines = response.data.split('\n').filter(i => i.trim() !== '')

          var matrix = lines.map((line, y) => line.split(/\s+/).map((z, x) => { return {x, y, z: parseFloat(z)} }).filter(i => { return i.z !== 0 }))

          var nodes = task.results.ind.map((ind, i) => {
            return {
              index: i,
              name: ind.name,
              aci: matrix[i].reduce((sum, d) => sum + d.z, 0)
            }
          })
          var indices = nodes.map((node, i) => { return i * width / n })

          // Precompute the orders.
          var orders = {
            sequence: d3.range(n),
            name: d3.range(n).sort(function (a, b) { return d3.ascending(nodes[a].name, nodes[b].name) }),
            aci: d3.range(n).sort(function (a, b) { return d3.ascending(nodes[a].aci, nodes[b].aci) })
          }

          // The default sort order.
          var x = d3.scaleOrdinal().domain(orders.sequence).range(indices)
          var xRangeBand = width / n

          svg.append('rect')
          .attr('fill', '#eee')
          .attr('width', width)
          .attr('height', height)

          var row = svg.selectAll('.row')
          .data(matrix)
          .enter().append('g')
          .attr('class', 'row')
          .attr('transform', function (d, i) { return 'translate(0,' + x(i) + ')' })
          .each(eachRow)

          row.append('line')
          .attr('x2', width)
          .attr('stroke', '#fff')

          row.append('text')
          .attr('x', -6)
          .attr('y', xRangeBand / 2)
          .attr('dy', '.32em')
          .attr('text-anchor', 'end')
          .text(function (d, i) { return nodes[i].name })

          var column = svg.selectAll('.column')
          .data(matrix)
          .enter().append('g')
          .attr('class', 'column')
          .attr('transform', function (d, i) { return 'translate(' + x(i) + ')rotate(-90)' })

          column.append('line')
          .attr('x1', -width)
          .attr('stroke', '#fff')

          column.append('text')
          .attr('x', 6)
          .attr('y', xRangeBand / 2)
          .attr('dy', '.32em')
          .attr('text-anchor', 'start')
          .text(function (d, i) { return nodes[i].name })

          function eachRow (r) {
            var data = r.filter(d => { return d.z > 0 })
  //          console.log(data)
            d3.select(this).selectAll('.cell')
            .data(data)
            .enter().append('rect')
            .attr('class', 'cell')
            .attr('x', d => {
  //            console.log(`d.x: ${d.x}`)
  //            console.log(`x(d.x): ${x(d.x)}`)
              return x(d.x)
            })
            .attr('width', xRangeBand)
            .attr('height', xRangeBand)
  //          .style('fill-opacity', function (d) { return d.z })
            .style('fill', function (d) { return c(d.z) })
            .on('mouseover', mouseover)
            .on('mouseout', mouseout)
          }

          function mouseover (p) {
            d3.selectAll('.row text').attr('fill', function (d, i) { return i === p.y ? 'red' : 'black' })
            d3.selectAll('.column text').attr('fill', function (d, i) { return i === p.x ? 'red' : 'black' })
            v.popupStyle.left = `${d3.event.clientX + 20}px`
            v.popupStyle.top = `${d3.event.clientY}px`
            v.popupText = `${nodes[p.y].name} ${nodes[p.x].name}: ${p.z}`
            v.popupStyle.display = 'block'
          }

          function mouseout () {
            d3.selectAll('text').attr('fill', 'black')
            v.popupStyle.display = 'none'
          }

          d3.select('#correlation-order').on('change', function () {
            clearTimeout(timeout)
            order(this.value)
          })

          function order (value) {
            x.domain(orders[value])

            var t = svg.transition().duration(2500)

            t.selectAll('.row')
            .delay(function (d, i) { return x(i) * 4 })
            .attr('transform', function (d, i) { return 'translate(0,' + x(i) + ')' })
            .selectAll('.cell')
            .delay(function (d) { return x(d.x) * 4 })
            .attr('x', function (d) { return x(d.x) })

            t.selectAll('.column')
            .delay(function (d, i) { return x(i) * 4 })
            .attr('transform', function (d, i) { return 'translate(' + x(i) + ')rotate(-90)' })
          }

          var timeout = setTimeout(function () {
            order('sequence')
            d3.select('#order').property('selectedIndex', 2).node().focus()
          }, 5000)

          v.matrixReady = true
        }).catch(error => {
          console.log(error)
        })
      } else {
        setTimeout(() => {
          v.checkTask()
        }, 500)
      }
    }
  },

  mounted () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../styles/theme.scss";


.box-head {
  padding: 10px;
  border-bottom: 1px solid #eeeeee;
  background-color: $theme-color;
  font-weight: 700;
  color: white;
}

.box-tool {
  padding:10px 0px;
  /*
  border-bottom:1px solid #eeeeee
  */
}

</style>
